import { postRequest, getRequest } from '../utils/request';

export const getFileUrl = async (fileId) => getRequest(`/file/${fileId}`);